module.exports = __webpack_public_path__ + "static/media/solviawhite.77388815.png";